import { render } from "./App.vue?vue&type=template&id=c6e34b12"
const script = {}

import exportComponent from "C:\\Users\\DEV-HMP\\Documents\\TPM_Site\\Vendor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__